export default theme => {
    return {
        container: {
            marginBottom: 10,
            fontFamily: 'Roboto'
        },
        swatch: {
            width: 16,
            height: 16,
            borderRadius: 4,
            display: 'inline-block',
            marginRight: 5
        },
        item: {
            padding: '3px !important'
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/configuration/CategoryTentpoleEvents/theme/components/scorecard/ScorecardView/ScorecardLegend.js